module.exports = __webpack_public_path__ + "static/media/scene_three.072926b4.png";